import React from "react";
import "./Loading.css";

export default function Loading() {
  return (
    <div className="loading-section">
      <span>Loading emojis...</span>
    </div>
  );
}
